import { createAction } from 'redux-actions';

export const CREATE_NOTIFICATION = 'CREATE_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';

export const createNotification = createAction(CREATE_NOTIFICATION);
export const removeNotification = createAction(REMOVE_NOTIFICATION);
